import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { Title, Meta } from '@angular/platform-browser';


import { ServicesService } from './../services.service';

@Component({
  selector: 'app-services-details',
  templateUrl: './services-details.component.html',
  styleUrls: ['./services-details.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class ServicesDetailsComponent implements OnInit, OnDestroy {

	public data = {
		'name' : '',
		'description': '',
		'image': '',
		'seoTitle': '',
		'seoDescription': '',
	};
	private slug: any;
    private inscription: Subscription;

	constructor(private _service: ServicesService,
				private _router: Router,
				private _activeRoute: ActivatedRoute,
				private _titleService: Title,
				private _meta: Meta) { }

	ngOnInit() {
		this.inscription = this._activeRoute.params.subscribe(
            (params: any) => {
                this.slug = params['slug'];
                if (this.slug) {
                    this._service.getItem(this.slug)
                    .subscribe(
                        response => {
						   this.data = response;

						   this._titleService.setTitle(response['name'] + ' - Hospital Veterinário Stolf');
						   this._meta.addTag({
							   name: 'title',
							   content: response['seoTitle']
						   });
						   this._meta.addTag({
							   name: 'description',
							   content: response['seoDescription']
						   });
                        },
                        error => {
                            console.error ( error );
                        }
                    );
                } else {
                    // 404 error
                }
            }
        );
	}

	ngOnDestroy() {
		this.inscription.unsubscribe();
	}

}



// WEBPACK FOOTER //
// /Users/henriquezanini/Sites/Cães e Gatos/site/src/app/services/services-details/services-details.component.ts